import { MarketoForm } from '@gonfalon/marketing-forms/forms';
import { isUnifiedFormSubmitEnabled } from '@gonfalon/marketing-forms/isUnifiedFormSubmitEnabled';

import { ContactSalesFormFields } from './internal/ContactSalesFormFields';
import { ContactSalesFormLegacy } from './internal/ContactSalesFormLegacy';
import type { ContactSalesFormProps } from './internal/types';

export type { ContactSalesFormProps } from './internal/types';

/**
 * The contact sales form body, for rendering inside a modal.
 *
 * Switches between the backend submit path and the Marketo client script per
 * `release-unified-form-submit`, so the cutover can be rolled back without a
 * deploy. Remove `ContactSalesFormLegacy` once the flag is fully released.
 */
export function ContactSalesForm(props: ContactSalesFormProps) {
  return isUnifiedFormSubmitEnabled(MarketoForm.ContactSales) ? (
    <ContactSalesFormFields {...props} />
  ) : (
    <ContactSalesFormLegacy {...props} />
  );
}
